import styles from "./LeadWhatsApp.module.css";

export const CHANNEL_MAIL = "mail";
export const CHANNEL_WHATSAPP = "whatsapp";

const TABS = [
  { id: CHANNEL_MAIL, label: "Correo" },
  { id: CHANNEL_WHATSAPP, label: "WhatsApp" },
];

const LeadChannelTabs = ({ channel = CHANNEL_MAIL, onChange }) => (
  <div className={styles.channelTabs} role="tablist" aria-label="Canal de comunicación">
    {TABS.map((tab) => {
      const active = channel === tab.id;
      return (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={active}
          className={`${styles.channelTab} ${active ? styles.channelTabActive : ""}`}
          onClick={() => {
            if (!active) onChange?.(tab.id);
          }}
        >
          {tab.label}
        </button>
      );
    })}
  </div>
);

export default LeadChannelTabs;
